import Codec from "./Codec.mts";
import Tagged from "./Tagged.mts";

type Json<T extends unknown = unknown> = Tagged<string, "Json", T>;

namespace Json {
  export type Decoded<T extends string> = Tagged.Meta<T, "Json", unknown>;

  export const encode = <T,>(value: T): Json<T> =>
    JSON.stringify(value) as Json<T>;
  export const decode = <Json extends string>(json: Json) =>
    JSON.parse(json) as Decoded<Json>;

  export const codec = { encode, decode } satisfies Codec<unknown, string>;
}

export default Json;
